module.exports = require('./lib/sync');



//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-persist-transform-encrypt/index.js
// module id = 1084
// module chunks = 0